module.exports = __webpack_public_path__ + "img/d20190727-1.d42a3803.jpg";